<template>
  <v-container class="services-container">
    <h2 class="secondary--text text-xs-center hidden-xs-only">
      <i>{{ $t('Home.Services.Titre').slice(0, 47) }}
        <br/>{{ $t('Home.Services.Titre').slice(47, 1000) }}
      </i>
    </h2>
    <h2 class="secondary--text text-xs-center hidden-sm-and-up">
      <i>{{ $t('Home.Services.Titre') }}</i>
    </h2>
    <v-layout row wrap>
      <v-flex xs12 sm12 md4 lg4 class="px-4">
        <div class="secondary services-icon my-3">
          <img src="@/assets/bank-line.svg" />
        </div>
        <h4 class="secondary--text">{{ $t('Home.Services.Service1') }}</h4>
        <p class="text-xs-center my-3">{{ $t('Home.Services.P1') }}</p>
      </v-flex>
      <v-flex xs12 sm12 md4 lg4 class="px-4">
        <div class="primary services-icon my-3">
          <img src="@/assets/shield-check-line.svg" />
        </div>
        <h4 class="primary--text">
          <span>{{ $t('Home.Services.Service2') }}</span>
        </h4>
        <p class="text-xs-center my-3">{{ $t('Home.Services.P2') }}</p>
      </v-flex>
      <v-flex xs12 sm12 md4 lg4 class="px-4">
        <div class="accent services-icon my-3">
          <img src="@/assets/help-info-line.svg" />
        </div>
        <h4 class="accent--text">{{ $t('Home.Services.Service3') }}</h4>
        <p class="text-xs-center my-3">{{ $t('Home.Services.P3') }}</p>
      </v-flex>
    </v-layout>
    <v-flex xs12 class="vertical-center py-4">
      <!-- <button class="section-btn">En savoir plus</button> -->
      <router-link to="/prestations" tag="button" class="section-btn">En savoir plus</router-link>
    </v-flex>
  </v-container>
</template>

<script>

export default {
  name: 'services-section',
  data () {
    return {
    }
  }
}
</script>

<style>
.services-icon {
  width: 80px;
  height: 80px;
  margin: auto;
  display: flex;
  justify-content: center;
}

.services-icon img {
  width: 50px;
}
/* Style for medium devices */
.mdOnly .services-container h2 {
  font-size: 1.6rem;
}
/* Style for small devices */
.smOnly .services-container h2 {
  padding: 0 0;
  font-size: 18px;
  margin-bottom: 16px;
}
.smOnly .services-container h4 {
  font-size: 16px;
}
.smOnly .services-container p {
  font-size: 16px;
  margin-top: 0 !important;
}
.smOnly .services-icon {
  width: 60px;
  height: 60px;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.smOnly .services-icon img {
  width: 36px;
}
/* Style for extra small devices */
.xsOnly .services-container h2 {
  padding: 0 0;
  font-size: 13px;
  letter-spacing: -0.3px;
  margin-bottom: 8px;
}
.xsOnly .services-container h4 {
  font-size: 13px;
  height: 40px;
}
.xsOnly .services-container p {
  font-size: 12px;
  margin-top: 0 !important;
}
.xsOnly .services-icon {
  width: 50px;
  height: 50px;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.xsOnly .services-icon img {
  width: 36px;
}
</style>
